import TreeNode from "./TreeNode";

export default class CustomerTreeNode extends TreeNode {
    constructor(customer, id) {
        super(customer, id);
    }

    getIdPrefix() {
        return "c";
    }

    getType() {
        return TreeNode.TYPE_CUSTOMER
    }
}



// WEBPACK FOOTER //
// ./web/js/hierarchySelector/tree/CustomerTreeNode.js